import { Injectable } from '@angular/core';
import { API_MAP } from 'app/core/helpers/api.map';
import { Result } from 'app/core/models/result';
import { BaseDataService } from 'app/core/services/base-data.service';
import { Observable, tap } from 'rxjs';
import { Article } from '../models/article.model';

@Injectable()
export class ArticleService extends BaseDataService<Article> {
  override controller = API_MAP.article;

  override get(controller?: string): Observable<Result<any>> {
    return super.get(controller ?? this.controller).pipe(
      tap((d: any) => {
        this.content.set(d.content);
        this.components.set(d.components);
      })
    );
  }
}
